import { render, staticRenderFns } from "./drop-ginga.vue?vue&type=template&id=63adaa8e&scoped=true&"
import script from "./drop-ginga.vue?vue&type=script&lang=js&"
export * from "./drop-ginga.vue?vue&type=script&lang=js&"
import style0 from "./drop-ginga.vue?vue&type=style&index=0&id=63adaa8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63adaa8e",
  null
  
)

export default component.exports